/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchCertification
 */
export interface SourcingSearchCertification {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchCertification
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchCertification
     */
    organization?: string;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchCertification
     */
    graduationYear?: number;
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchCertification
     */
    link?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SourcingSearchCertification
     */
    keywords?: Array<string>;
}

/**
 * Check if a given object implements the SourcingSearchCertification interface.
 */
export function instanceOfSourcingSearchCertification(value: object): value is SourcingSearchCertification {
    return true;
}

export function SourcingSearchCertificationFromJSON(json: any): SourcingSearchCertification {
    return SourcingSearchCertificationFromJSONTyped(json, false);
}

export function SourcingSearchCertificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchCertification {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'organization': json['organization'] == null ? undefined : json['organization'],
        'graduationYear': json['graduationYear'] == null ? undefined : json['graduationYear'],
        'link': json['link'] == null ? undefined : json['link'],
        'keywords': json['keywords'] == null ? undefined : json['keywords'],
    };
}

export function SourcingSearchCertificationToJSON(value?: SourcingSearchCertification | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'organization': value['organization'],
        'graduationYear': value['graduationYear'],
        'link': value['link'],
        'keywords': value['keywords'],
    };
}

